module.exports = __webpack_public_path__ + "static/media/give_shop_bg.058a7bf0.png";